import React from "react";
import Input from "../common/Input";

function JAH({ data, handleChange, handleSave }) {
  return (
    <div>
      <div className="col-4">
        <Input
          name="currentFacility"
          label="Current Residential Facility"
          onChange={handleChange}
          value={data.DynamicFields.results.currentFacility}
        />
      </div>
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </div>
  );
}

export default JAH;
